import { tap, withLatestFrom } from 'rxjs';

import { Injectable } from '@angular/core';
import { resetStateAction } from '@ideapa/app-common';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { RouterFacade } from '@ideapa/app-routing-utils';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { Store } from '@ngrx/store';

import * as NavigationActions from './navigation.actions';
import { NavigationFacade } from './navigation.facade';

@Injectable()
export class NavigationEffects {
  constructor(
    private actions$: Actions,
    private facade: NavigationFacade,
    private store: Store,
    private routerFacade: RouterFacade
  ) {}

  closeTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NavigationActions.closeTab),
        withLatestFrom(this.facade.tabs$),
        tap(([action, tabs]) => {
          this.store.dispatch(resetStateAction({ entity: action.path }));

          if (action.navigate) {
            this.store.dispatch(NavigationActions.navigateToFirstTab());
          }
        })
      ),
    { dispatch: false }
  );

  navigateToFirstAvailableTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NavigationActions.navigateToFirstTab),
        withLatestFrom(this.facade.tabs$),
        tap(([action, tabs]) => {
          const firstOpenedTabPath = tabs.find((t) => t.tabOpened)?.path;
          this.routerFacade.navigateRelative(
            [firstOpenedTabPath || ''],
            false,
            null
          );
        })
      ),
    { dispatch: false }
  );

  closeModuloRelatedTabs$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NavigationActions.closeModuloRelatedTabs),
        withLatestFrom(this.facade.tabs$),
        tap(([action, tabs]) => {
          const tabsToClose = tabs
            .filter((t) => t.tabOpened && t.modulo)
            .map((t) => t.path);

          tabsToClose.forEach((element) => {
            // console.log(`closeModuloRelatedTabs tabsToClose: `, element);
            this.store.dispatch(
              NavigationActions.closeTab({ path: element, navigate: false })
            );
          });

          this.store.dispatch(NavigationActions.navigateToFirstTab());
        })
      ),
    { dispatch: false }
  );

  closeEnteAnnoRelatedTabs$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NavigationActions.closeEnteAnnoRelatedTabs),
        withLatestFrom(this.facade.tabs$),
        tap(([action, tabs]) => {
          const tabsToClose = tabs
            .filter((t) => t.tabOpened && (t.ente || t.anno))
            .map((t) => t.path);

          tabsToClose.forEach((element) => {
            console.log(`closeEnteAnnoRelatedTabs tabsToClose: `, element);
            this.store.dispatch(
              NavigationActions.closeTab({ path: element, navigate: false })
            );
          });

          this.store.dispatch(NavigationActions.navigateToFirstTab());
        })
      ),
    { dispatch: false }
  );

  navigate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(routerNavigatedAction),
        // withLatestFrom(this.facade.tabs$),
        tap((action) => {
          this.facade.showTab(action.payload.routerState.url);
        })
      ),
    { dispatch: false }
  );

  // apiError$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(ErrorActions.addApiErrorMsg),
  //       tap((action) => {
  //         if (action.errorMessage) {
  //           this.toastService.errorFeedback(action.errorMessage);
  //         }
  //         console.error(action.errorMessage);
  //       })
  //     ),
  //   { dispatch: false }
  // );

  // error$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(ErrorActions.addError),
  //       tap((action) => {
  //         console.error('Errore imprevisto:', action.error);
  //       })
  //     ),
  //   { dispatch: false }
  // );
}
